"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a, _b;
    return (0, core_1.createStyles)({
        container: material_kit_pro_react_1.container,
        pollBtn: (_a = {
                width: '40%',
                alignSelf: 'center'
            },
            _a[theme.breakpoints.down('xs')] = {
                marginBottom: theme.spacing(4)
            },
            _a),
        pollOption: {
            marginBottom: theme.spacing(2),
            position: 'relative',
            minHeight: 36
        },
        pollAnswer: {
            position: 'relative',
            padding: theme.spacing(2),
            zIndex: 2
        },
        pollBackground: {
            height: '100%',
            borderRadius: '0px 5px 5px 0px',
            minHeight: 36,
            position: 'absolute',
            top: 0,
            zIndex: 1
        },
        PollAnswerAll: (_b = {
                paddingTop: theme.spacing(6),
                paddingBottom: theme.spacing(6),
                textAlign: 'center'
            },
            _b[theme.breakpoints.down('xs')] = {
                paddingLeft: theme.spacing(4),
                paddingRight: theme.spacing(4)
            },
            _b)
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map